import { useGetDashboardTodo } from 'api/hooks/dashboard/use-get-dashboard-todo-items';
import { RenderUnsettledUI } from 'shared/components';
import { useParams } from 'react-router-dom';
import { useCompanyRelativePath } from 'ogp/hooks';
import { useSiteDetection } from 'shared/hooks';
import { TodoSection } from './todo-list';

export const TodoSectionDataProvider = () => {
  const { companyId } = useParams();
  const { site } = useSiteDetection();
  const generatePath = useCompanyRelativePath();

  const { refetch, status, data, error } = useGetDashboardTodo(site);

  if (status !== 'success') {
    return <RenderUnsettledUI data={{ error, refetch, status }} />;
  }

  return <TodoSection data={data} generatePath={generatePath} companyId={companyId} />;
};
